import React, { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { getEventsAll } from '../../api/events';
import { EventsCarrousel } from '../../components/EventsCarrousel/EventsCarrousel';
import { EventsGrid } from '../../components/EventsGrid/EventsGrid';
import { EventsSkeleton } from '../../components/EventsSkeleton/EventsSkeleton';
import { definedTranslation } from '../../i18n';
import {
  featuredEventsListSelector,
  upcomingEventsListSelector,
  eventsErrorMessageSelector,
  eventsLoadedSelector,
} from '../../redux/events/eventsSelector';
import { useAppDispatch, useAppSelector } from '../../redux/store';

export const EventsContainer: FC = () => {
  const intl = useIntl();
  const featuredTitle = intl?.formatMessage(definedTranslation.events.featured);
  const upcomingTitle = intl?.formatMessage(definedTranslation.events.upcoming);
  const dispatch = useAppDispatch();
  const featuredEvents = useAppSelector(featuredEventsListSelector);
  const upcomingEvents = useAppSelector(upcomingEventsListSelector);
  const errorMessage = useAppSelector(eventsErrorMessageSelector);
  const error = errorMessage ? true : false;
  const isLoading = !useAppSelector(eventsLoadedSelector);

  const loadEventsData = () => {
    console.log('start loading events data');
    dispatch(getEventsAll());
  };

  useEffect(() => {
    loadEventsData();
  }, []);

  if (error) {
    return <div className="mt-4 text-center">Error: {errorMessage}</div>;
  }

  if (isLoading) {
    return <EventsSkeleton />;
  }

  if (!upcomingEvents || upcomingEvents.length === 0) {
    return <div className="mt-4 text-center">No events found</div>;
  }

  return (
    <>
      <EventsCarrousel
        events={featuredEvents}
        title={featuredTitle}
        eventLocation={null}
        isFeatured={true}
        slideLimit={2}
      />
      <EventsGrid
        events={upcomingEvents}
        title={upcomingTitle}
        isFeatured={false}
      />
    </>
  );
};
